const guestAppLoadTimeout = 60000;

const constants = {
  guestAppLoadTimeout,
};

export default constants;
